<div
  #originRef
  class="flex items-center rounded cursor-pointer relative trans-ease-out select-none py-1 pr-1 pl-3 hover:bg-hover"
  style="width: 180px"
  matRipple
>
  <div
    #userProfileMenuOriginRef
    (click)="openProfileMenu(userProfileMenuOriginRef)"
    [class.ratenow-sidenav-user--open]="userMenuOpen$ | async"
    class="ratenow-sidenav-user flex flex-auto items-center"
    matRipple
    matRippleColor="var(--sidenav-item-ripple-color)"
  >
    <div
      class="body-1 flex flex-auto font-medium leading-snug ltr:mr-3 rtl:ml-3 sm:block"
    >
      {{ userLoggedName }}
    </div>
    <div
      class="rounded-full h-9 w-9 flex items-center justify-center text-primary bg-primary/10"
    >
      <img
        [src]="imageId()"
        class="avatar"
        (error)="imageId.set(defaultImage)"
      />
    </div>
  </div>
</div>
